module.exports = __webpack_public_path__ + "static/videoAcademy-fc336140f6db904641425092ff309339.mp4";